<template>
  <b-container>
    <b-card class='text-center'>
      <h2>Login</h2>
      <b-button @click="signin_google"><i class="fab fa-google" variant="primary"></i> Login with Google</b-button>
    </b-card>
  </b-container>
</template>

<script>

import { db, auth, _firebase } from '@/main.js'
import constants from '@/lib/constants.js'

export default {
  name: 'login',
  props: ['profile'],
  methods: {
    async signin_google() {
      let result = await auth.signInWithPopup(new _firebase.auth.GoogleAuthProvider())

      let user = result.user
      if (result && result.additionalUserInfo && result.additionalUserInfo.isNewUser) {
        await db.collection('user').doc(user.uid).set({
          created: new Date(),
          updated: new Date(),
          email: user.email,
          name: user.displayName,
          roles: constants.roles.user,
          payment_method: null,
        })
      }
    }
  },
  metaInfo() {
    return {
      title: `login`
    };
  },
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$router.push({name: 'sites'})
      }
    })
  }
}
</script>

<style scoped>

.card {
  max-width: 16em;
  margin: auto;
}

.container {
  margin-top: 8em;
}

</style>
